import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getSiriusUsers = createAsyncThunk('/getSiriusUsers', async () => {
  const response = await axiosHeadOffice.get('/HeadOffice/GetSiriusUsers');
  return response.data;
});

const userSlice = createSlice({
  name: 'user',
  initialState: {
    selectedItemId: 0, loading: '', error: '', SiriusUser: []
  },
  reducers: {
    changeselectedItemId(state, action) {
      state.selectedItemId = action.payload;
    }
  },
  extraReducers: {
    [getSiriusUsers.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getSiriusUsers.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getSiriusUsers.fulfilled]: (state, action) => {
      state.SiriusUser = action.payload;
      state.loading = 'Finished';
    }
  }
});

export const userActions = userSlice.actions;

export default userSlice;
